
import XHeader from 'vux/src/components/x-header/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

import * as axios from "@/store/index";
import { mapActions } from "vuex";
import Vue from "vue";
import beas64 from "./js/beas64.js"; 
export default {
name: "home",
components: {
XHeader,
Loading,
Alert
},

data() {
return {
title: "",
isCn: true,
isShowAdd: false,
locale: "en", //默认中文

alterMsg: "Failed to get data, please try again later!",
isShowAlter: false, //不打包的时候用

isback: false,
theme: 0
};
},
methods:{
/**
* 页面初始化之前鉴权门户
*/
checkportal(){







}
},
mounted() {





this.initTheme()
},
beforeCreate() {






}
};



// WEBPACK FOOTER //
// ./src/App.vue